/** Keep in sync with aibe project.schema (PROJECT_NAME_MAX_LENGTH / PROJECT_DESCRIPTION_MAX_LENGTH). */
export const PROJECT_NAME_MAX_LENGTH = 100;
export const PROJECT_DESCRIPTION_MAX_LENGTH = 1000;
export const PROJECT_INSTRUCTIONS_MAX_LENGTH = 8000;

export const PROJECTS_ROUTE = '/projects';
export const projectRoute = (projectId: string) => `${PROJECTS_ROUTE}/${projectId}`;

/** Memories added from the project UI are free-form notes stored under this category / key prefix. */
export const PROJECT_MEMORY_CATEGORY = 'custom';
export const PROJECT_MEMORY_KEY_PREFIX = 'custom.note';
export const PROJECT_MEMORY_MAX_LENGTH = 5000;
